import { Capacitor } from "@capacitor/core";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { ConvexProvider, ConvexReactClient } from "convex/react";

import "./features/onboarding/onboardingBootstrap";
import { App } from "./app/App";
import { Screen0LanguageProvider } from "./features/language";
import { Screen0IntlProvider } from "./i18n";
import { DeviceProvider } from "./lib/device/DeviceProvider";
import { MarketingDemoProvider } from "./lib/marketing/MarketingDemoProvider";
import { BottomSheetStackProvider } from "./features/habits/BottomSheet";
import { KeyboardInsetProvider } from "./lib/native/KeyboardInsetProvider";
import { SwipeUnlockChromeProvider } from "./lib/layout/SwipeUnlockChromeProvider";
import { TrackingProvider } from "./lib/native/tracking";
import { UsageAccessProvider } from "./lib/native/usageAccess";
import "./styles.css";

if (Capacitor.isNativePlatform()) {
  document.documentElement.dataset.screen0Native = "true";
}

const convexUrl = import.meta.env.VITE_CONVEX_URL;

if (!convexUrl) {
  throw new Error("VITE_CONVEX_URL is required for Screen0 builds.");
}

const convex = new ConvexReactClient(convexUrl);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConvexProvider client={convex}>
      <BrowserRouter>
        <Screen0LanguageProvider>
          <Screen0IntlProvider>
            <DeviceProvider>
              <MarketingDemoProvider>
                <KeyboardInsetProvider>
                  <BottomSheetStackProvider>
                    <SwipeUnlockChromeProvider>
                      <UsageAccessProvider>
                        <TrackingProvider>
                          <App />
                        </TrackingProvider>
                      </UsageAccessProvider>
                    </SwipeUnlockChromeProvider>
                  </BottomSheetStackProvider>
                </KeyboardInsetProvider>
              </MarketingDemoProvider>
            </DeviceProvider>
          </Screen0IntlProvider>
        </Screen0LanguageProvider>
      </BrowserRouter>
    </ConvexProvider>
  </StrictMode>,
);
